import con from '../../../../connection';

const path = '/confirmed';

const confirmed = (url: string) => (planId: string, applicationId: number) => ({
  post: () => con.post(url + '/' + planId + '/' + applicationId + path, {}),
});

export default confirmed;